/**
 * Components / Templates: Quantity Selector
 * ------------------------------------------------------------------------------
 * Handles the quantity selector base template for use in scripts.
 *
 * - Should be kept inline with quantity-selector.liquid.
 * - Built to be used in any component rendering.
 *
 */
import { misc as icons } from '~/helpers/svg-map';
/**
 * Get quantity selector template.
 * @param {Object} item - Cart item to get properties from.
 * @param {Integer} index - Unique index to bind component to.
 * @param {String} namespace - The namespace of the context.
 * @returns {String}
 */

export default (function (item, index) {
  let namespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'quantity-selector';

  function getMaxInventory() {
    if (item.properties !== null) {
      return item.properties._max_inventory;
    }

    return 999;
  }

  return "\n    <label\n      class=\"visually-hidden\"\n      for=\"Quantity-".concat(index, "\"\n      tabindex=\"0\"\n    >\n      ").concat(theme.strings.cart.label.quantity, "\n    </label>\n\n    <div\n      id=\"QuantitySelector-").concat(index, "\"\n      class=\"quantity-selector quantity-selector--small\"\n      data-available=\"true\"\n      data-max=\"").concat(getMaxInventory(), "\"\n      js-").concat(namespace, "=\"quantitySelector\"\n    >\n      <div class=\"quantity-selector__control\">\n        <button\n          class=\"button quantity-selector__button\"\n          value=\"decrement\"\n          js-quantity-selector=\"decrement\"\n        >\n          <span class=\"visually-hidden\">-</span>\n          ").concat(icons.minus, "\n        </button>\n      </div>\n\n      <div class=\"quantity-selector__control\">\n        <input\n          id=\"Quantity-").concat(index, "\"\n          class=\"quantity-selector__input\"\n          min=\"1\"\n          name=\"quantity\"\n          pattern=\"[0-9]*\"\n          readonly\n          type=\"number\"\n          value=\"").concat(item.quantity, "\"\n          js-quantity-selector=\"input\"\n        />\n      </div>\n\n      <div class=\"quantity-selector__control\">\n        <button\n          class=\"button quantity-selector__button\"\n          value=\"increment\"\n          data-cy=\"quantityIncrease\"\n          js-quantity-selector=\"increment\"\n        >\n          <span class=\"visually-hidden\">+</span>\n          ").concat(icons.plus, "\n        </button>\n      </div>\n    </div>\n  ");
});